module.exports = __webpack_public_path__ + "img/money.f4c28047.jpg";